export const ACCOUNT_DEACTIVATED_CODE = 'ACCOUNT_DEACTIVATED';
export const DEACTIVATED_MESSAGE =
  'Your account has been deactivated. Please contact HR/Admin.';

export function isUserAccountActive(user) {
  if (!user) return false;
  if (user.isActive === false) return false;
  const employee = user.employee;
  if (employee && typeof employee === 'object' && employee.isActive === false) {
    return false;
  }
  return true;
}

export function clearAuthStorage() {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
}

export function setDeactivatedRedirectMessage(message = DEACTIVATED_MESSAGE) {
  sessionStorage.setItem('authRedirectMessage', message);
}

export function consumeDeactivatedRedirectMessage() {
  const message = sessionStorage.getItem('authRedirectMessage');
  if (message) {
    sessionStorage.removeItem('authRedirectMessage');
  }
  return message;
}
